/** Which front door was used: the customer address or the staff address.
 *  Empty REACT_APP_CUSTOMER_HOSTS means one shared address and nothing changes. */

const configured = (process.env.REACT_APP_CUSTOMER_HOSTS || "")
  .split(",")
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

export const customerHosts = configured;

export const customerHost = configured[0] || "";

export function isCustomerHost() {
  if (typeof window === "undefined") return false;
  // ?view=customer only ever takes features away, so it is safe to allow anywhere.
  if (new URLSearchParams(window.location.search).get("view") === "customer") return true;
  return configured.includes(window.location.hostname.toLowerCase());
}

export function customerPortalUrl() {
  return customerHost ? `https://${customerHost}/invoices` : "/invoices";
}
